import { Autocomplete, Box, Button, CircularProgress, Paper, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { Colors } from '../../../../Styles/Colors'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { DateTime } from 'luxon'
import RestAPIService from '../../../../Utility/Services/RestAPIService'

async function parseBlobError(responseBlob) {
  try {
    // Convert Blob to text
    const errorText = await responseBlob.text();
    const errorJson = JSON.parse(errorText);
    console.error("Parsed Error:", errorJson);
    return errorJson.message;
  } catch (parseError) {
    console.error("Error parsing Blob response:", parseError);
    return "";
  }
}

const PharmaGenerateReport = () => {
    const yesterday = new Date();
    // yesterday.setDate(yesterday.getDate() - 1);
    const [states, setStates] = useState({
        reportData: ['Purchase GRN Wise Report', 'Sales TAX Wise Report', 'Day End Detailed Sales Report'],
        DatePickerOpen: false,
        DatePickerOpen2: false,
        datePicker: yesterday,
        datePicker2: yesterday,
        apiNextDate: "",
        reportType: null,
        isLoader: false,
        loader: false,
    })
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const getExcelReport = () => {
        try {
            let fromStartDate = new Date(states.datePicker)
            let toStartDate = new Date(states.datePicker2)
            let fromDate = DateTime.fromJSDate(fromStartDate).toFormat('yyyy-MM-dd')
            let toDate = DateTime.fromJSDate(toStartDate).toFormat('yyyy-MM-dd')
            let URLS = ''
            switch (states.reportType) {
                case 'Purchase GRN Wise Report':
                    URLS = Serviceurls.PHARMA_PURCHASE_GRN_WISE_REPORT_EXCEL
                    break;
                case 'Sales TAX Wise Report':
                    URLS = Serviceurls.PHARMA_SALES_GRN_WISE_REPORT_EXCEL
                    break
                case 'Day End Detailed Sales Report':
                    URLS = Serviceurls.PHARMA_DAY_END_DETAIL_SALES_REPORT
            }
            RestAPIService.excelGetAccReport(URLS + `?from_date=${fromDate}&to_date=${toDate}&export=excel`)
                .then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data; //here we load our csv data 

                        let filename = response.headers["content-disposition"].split("filename=")[1]

                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'Purchase.xlsx');
                        pom.click();
                        setStates((prev) => ({ ...prev, isLoader: false }))
                    }
                }).catch(async (error) => {
                    setStates((prev) => ({ ...prev, isLoader: false }))
                    if (error.response && error.response.data) {
                        if (error.response.data instanceof Blob) {
                            const errorMessages = await parseBlobError(error.response.data);
                            if (errorMessages) {
                                errorMessage(errorMessages);
                            }
                        } else if (error.response.data?.message) {
                            errorMessage(error.response.data?.message)
                        }
                    } else {
                        errorMessage(error?.message)
                    }
                })
        } catch (error) {
            setStates((prev) => ({ ...prev, isLoader: false }))
            errorMessage(error.message)
        }
    }

    return (
        <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} sx={{ backgroundColor: Colors.Background, height: '80dvh' }}>
            <Paper sx={{ width: '25vw', height: '24vw', backgroundColor: 'white', borderRadius: '.3vw' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography sx={{ fontSize: '1.1vw', fontWeight: 'bold', marginTop: '1vw' }}>Generate Report</Typography>
                </Box>
                <Box borderBottom={'1px solid lightgray'} marginTop={'1vw'}></Box>
                <Box sx={{ marginTop: '2vw', display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                open={states.DatePickerOpen}
                                onOpen={() => { setStates((prev) => ({ ...prev, DatePickerOpen: true })) }}
                                onClose={() => { setStates((prev) => ({ ...prev, DatePickerOpen: false })) }}
                                value={states.datePicker}
                                label='From Date'
                                minDate={new Date('2024-04-01')}
                                maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                                name={"datePicker"}
                                inputFormat='DD-MM-YYYY'
                                views={["year", "month", "day"]}
                                onChange={(newDate) => { setStates((prev) => ({ ...prev, datePicker: newDate })) }}
                                renderInput={(params) =>
                                    <TextField onKeyDown={(e) => e.preventDefault()} style={{ width: '18vw' }} size='small' {...params}
                                        onClick={() => { setStates((prev) => ({ ...prev, DatePickerOpen: true })) }} />}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                open={states.DatePickerOpen2}
                                onOpen={() => { setStates((prev) => ({ ...prev, DatePickerOpen2: true })) }}
                                onClose={() => { setStates((prev) => ({ ...prev, DatePickerOpen2: false })) }}
                                value={states.datePicker2}
                                label='To Date'
                                minDate={new Date('2024-04-01')}
                                maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                                name={"datePicker2"}
                                inputFormat='DD-MM-YYYY'
                                views={["year", "month", "day"]}
                                onChange={(newDate) => { setStates((prev) => ({ ...prev, datePicker2: newDate })) }}
                                renderInput={(params) =>
                                    <TextField onKeyDown={(e) => e.preventDefault()} style={{ width: '18vw', marginTop: '2vw' }} size='small' {...params}
                                        onClick={() => { setStates((prev) => ({ ...prev, DatePickerOpen2: true })) }} />}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Autocomplete
                            size='small'
                            disablePortal
                            id="gen-autocom"
                            options={states.reportData}
                            getOptionLabel={(option) => option}
                            onChange={(e, newValue) => { setStates((prev) => ({ ...prev, reportType: newValue })) }}
                            sx={{ width: '18vw', marginTop: '2vw' }}
                            renderInput={(params) => <TextField {...params} label="Type of Report" />}
                        />
                    </Box>
                    <Box sx={{ marginTop: '2vw', display: 'flex', justifyContent: 'center' }}>
                        <Button
                            size='small'
                            disabled={!states.reportType || states.isLoader}
                            variant='contained' sx={{ textTransform: 'capitalize', width: '12vw' }}
                            onClick={() => {
                                setStates((prev) => ({ ...prev, isLoader: true }));
                                getExcelReport();
                            }}>
                            {states.isLoader ? <CircularProgress size={'1.5vw'} color='inherit' /> : 'Generate'}
                        </Button>
                    </Box>
                </Box>
            </Paper>
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Box>
    )
}

export default PharmaGenerateReport